<i18n>
{
	"en": {
		"licencePlates": "Licence Plates",
		"licencePlate": "Licence Plate",
		"licencePlateExplanation": "GS1 SSCC (General Specification 1 Serial Shipping Container Code)",
		"addLicencePlate": "Add licence plate",
		"invalid": "Licence plate is invalid"
	},
	"no": {
		"licencePlates": "Kollinummer",
		"licencePlate": "Kollinummer",
		"licencePlateExplanation": "GS1 SSCC (General Specification 1 Serial Shipping Container Code)",
		"addLicencePlate": "Legg til kollinummer",
		"invalid": "Kollinummeret er ugyldig"
	}
}
</i18n>

<template>
	<t-input-wrapper
		:label="$t('licencePlates')"
		:description="$t('licencePlateExplanation')"
	>
		<t-tag-container
			:items="licencePlates"
			@change="$emit('change', $event)"
			@tag-click="openLicencePlate"
		>
			<template v-slot:before-tags>
				<t-button
					ref="addButton"
					key="add-licence-plate-button"
					:value="$t('addLicencePlate')"
					iconBefore="add"
					@click="addLicencePlate"
				/>
			</template>
		</t-tag-container>

		<t-dialog
			:isShown="showModal"
			focusFirstOnShow
			alwaysRememberFocus
			:title="$t('licencePlate')"
			:keyListeners="getKeyListeners()"
			@close="onDialogClose"
			@ok="setCurrentLicencePlate"
		>
			<t-number-input
				v-model="currentLicencePlate"
				:label="$t('licencePlate')"
				:isInvalid="currentIsInvalid"
				:validationMessage="$t('invalid')"
				@keydown.enter="onInputEnter"
			/>
		</t-dialog>
	</t-input-wrapper>
</template>

<script>
import { validateLicencePlate } from '@/core/validators';

export default {
	name: 'LicencePlates',
	props: {
		licencePlates: Array,
	},
	data() {
		return {
			currentLicencePlate: '',
			currentIndex: -1,
			showModal: false,
		};
	},

	computed: {
		currentIsInvalid() {
			return validateLicencePlate(this.currentLicencePlate);
		},
	},

	methods: {
		addLicencePlate() {
			this.showModal = true;
		},

		openLicencePlate(licencePlate) {
			this.$refs.addButton.focus();
			this.currentLicencePlate = licencePlate;
			this.currentIndex = this.licencePlates.indexOf(licencePlate);
			this.showModal = true;
		},

		setCurrentLicencePlate() {
			if (this.currentIsInvalid) return;
			let updatedLicencePlates = [...this.licencePlates];
			if (this.currentIndex >= 0) {
				updatedLicencePlates[this.currentIndex] = this.currentLicencePlate;
			} else {
				updatedLicencePlates.push(this.currentLicencePlate);
			}
			this.$emit('change', updatedLicencePlates);
		},

		onDialogClose() {
			this.currentLicencePlate = '';
			this.currentIndex = -1;
			this.showModal = false;
		},

		onInputEnter(event) {
			if (this.currentIsInvalid) return;
			event.preventDefault();
			event.stopPropagation();
			this.saveAndClose();
		},
		saveAndClose() {
			this.setCurrentLicencePlate();
			this.onDialogClose();
		},

		getKeyListeners() {
			return [
				{ 	key: 'S',
					listener: this.saveAndClose,
					modifiers: { ctrlKey: true, shiftKey: undefined, altKey: false, stop: true, prevent: true } },
				{ 	key: 'Enter',
					listener: this.saveAndClose,
					modifiers: { ctrlKey: true, shiftKey: false, altKey: false, stop: true, prevent: true } },
			];
		},
	},
};
</script>

<style lang="scss" scoped>
</style>
